import React from 'react';
import _ from '@dh-fe/translate';
import useMediaQuery from 'hooks/useMediaQuery';
import { Breakpoints } from 'configs/breakpoints';
import Image from 'components/Image/Image';
import { useTheme } from 'contexts/ThemeContext';
import classnames from 'classnames';
import { getContent } from './WorkSectionContent';
import style from './WorkSection.module.scss';

const WorkSection = () => {
    const isMobile = useMediaQuery(Breakpoints.VERY_SMALL);
    const { bg, bgMobileCompress, bgCompress, bgMobile, button, subtitle } = getContent();
    const { theme, isOranum } = useTheme();
    return (
        <section className={classnames(style[theme], style.workSection)}>
            {isMobile ? (
                <Image webp={bgMobileCompress} unCompressed={bgMobile} alt="background image" />
            ) : (
                <Image webp={bgCompress} unCompressed={bg} alt="background image" />
            )}
            <div className={style.container}>
                <h1>{_`Work whenever, wherever you want!`}</h1>
                <h2>{subtitle}</h2>
                {isOranum && <div className={style.registerBlock}>{button}</div>}
            </div>
        </section>
    );
};

export default WorkSection;
